import React from 'react'
import 'raf/polyfill'
import 'babel-polyfill'
import { connect } from 'react-redux'
import comFn from '../../component/common/common'
import axios from 'axios'
import HeaderBar from '../../component/header/header.js'
import LeftNav from '../../component/left-nav/leftNav.js'
import Login from '../../component/login/login.js'
import PagingBar from'../../component/paging-bar/paging.js'
import { Link} from "react-router-dom"
import './news-list.css'
import {getBigBGUrl} from '../../redux/chatuser.redux.js'
@connect(
  state=>state.chatuser,
  {getBigBGUrl}
)
class NewsList extends React.Component{
	constructor(props){
		super(props)
		this.state={
			///分页相关
		
				pageData:'',//当前渲染的页面数据          
	            currentPage: 1, //当前页码
	            pageSize:10, //每页显示的条数
	            //goValue:0,  //要去的条数index
	            total_page:0,//总页数,

	            newsTypeNum:0,

	      		
    	}
    	this.pageNext  = this.pageNext.bind(this)
    	this.total_page = 0	
	}
	componentDidMount(){
  
    	this.getNewsList(1)
    
  	}
	getNewsList(pCurrent){
		var  pType = this.state.newsTypeNum+1
		const {pageSize} = this.state
		axios.get('fapi/news/getNewsList?limit='+pageSize+'&&page_index='+pCurrent+'&&category='+pType+'')
		.then(res=>{
			
			if(res.data.return_code==0){
				
				this.setState({
					pageData:res.data.data,
					total_page :res.data.total_page
				})
				//this.total_page = res.data.total_page
				
			}
			
		})
	}
	pageNext(num){
		this.setState({
			currentPage:num
		})
		this.getNewsList(num)
  	}
	handleListOver(_Id){
		this.props.history.push('/news-detail/'+_Id)
	}
	tabNews(inum){
		
		this.setState({
			newsTypeNum:inum
		},function () {
			this.getNewsList(1)
		})

		
		

	}
	handleNewsOpt(itime){
      var num = itime.indexOf(' ')
     
      var mTime = itime.substring(0,num)
     	
       return mTime ||null
  	}
	render(){
		const pageData = this.state.pageData?this.state.pageData:null
		const newsType=["公告","活动","新闻"]
		
		return (
			<div className="my-wrap" style={{backgroundImage :'url('+this.props.bigBg+')'}}>
				<HeaderBar></HeaderBar>
				<div className="news-box">
					<Login showLogin={this.props.showLogin}>
		               
		            </Login>
					<div className="new-con">
						<div className="news-from"><Link to="/index">首页</Link> > 新闻公告</div>
						
						<div className="my-message-con news-con">
							<div>
								<div className="message-nav">
									{
										newsType.map((item,i)=>{
											return (
												<span 
													key={i} 
													className={ this.state.newsTypeNum==i?'active':''}
													onClick={()=>this.tabNews(i)}
												>{item}</span>

											)
	
										})
									}
									

								</div>
								
								<ul className="news-list">
									{
										pageData&&pageData.map((item,i)=>{
											
											return (		
							
												<li key={i}>
													{

														item.linkurl?<a href={item.linkurl} target="_blank"><strong>{item.title}</strong>
														 <em>{this.handleNewsOpt(item.start_time)}</em></a>:
														<span onClick={()=>this.handleListOver(item.id)}>
														 <strong>{item.title}</strong>
														 <em>{this.handleNewsOpt(item.start_time)}</em>
													 </span>
													}
													 
												</li>
											)
	
										})

									}
									
									
								</ul>
								{
									pageData&&pageData.length===0?<div className="no-news">
									<span>暂无新闻公告</span>
									</div>:null
								}
							</div>

					</div>
					<PagingBar 
						pageNext={this.pageNext} 
						totalPage={this.state.total_page}
					></PagingBar>
						
					</div>
				</div>
			</div>
		)
	}
}

export default NewsList



// WEBPACK FOOTER //
// ./src/container/news-list/news-list.js